import React, { useState } from 'react'
import { MapPin, Clock, Ship } from 'lucide-react'
import { motion } from 'framer-motion'

const item = (delay) => ({
  initial:  { opacity: 0, y: 22 },
  animate:  { opacity: 1, y: 0 },
  transition: { duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] },
})

export default function ItinHero({ title, thumb, duration, departure, cruise }) {
  const [loaded, setLoaded] = useState(false)

  return (
    <section className="si-hero">
      <div className={`si-hero__bg ${loaded ? 'si-hero__bg--zoom' : ''}`}>
        {thumb
          ? <img src={thumb} alt={title} onLoad={() => setLoaded(true)} />
          : <div className="si-hero__bg-fallback" />
        }
        <div className="si-hero__overlay" />
      </div>

      <div className="si-hero__content">
        <motion.div className="si-hero__eyebrow" {...item(0.1)}>
          Itinerary
        </motion.div>
        <motion.h1 className="ljn-display si-hero__title" {...item(0.25)}
          dangerouslySetInnerHTML={{ __html: title }}
        />
        <motion.div className="si-hero__meta" {...item(0.4)}>
          {duration && (
            <span className="si-hero__meta-item">
              <Clock size={13} strokeWidth={1.5} />
              {duration}
            </span>
          )}
          {departure && (
            <span className="si-hero__meta-item">
              <MapPin size={13} strokeWidth={1.5} />
              {departure}
            </span>
          )}
          {cruise?.permalink && (
            <a href={cruise.permalink} className="si-hero__meta-item si-hero__meta-cruise">
              <Ship size={13} strokeWidth={1.5} />
              {cruise.title}
            </a>
          )}
        </motion.div>
      </div>
    </section>
  )
}
